<template>
	<div style="height: 79vh; overflow-y: scroll;">
		<div v-if="is_create">
			<p>
				<a href="javascript:void(0)" @click="is_create = false"><i class="fa fa-arrow-left" style="cursor: pointer;"></i></a> Back
			</p>
			<create-event></create-event>
		</div>
		<div v-else>
			<div class="mt-3 mb-4" v-if="attendees.length > 0">
				<h5><b>Registed Users</b></h5>
				<table class="table  text-dark">
					<thead>
					<tr>
						<th>S.No</th>
						<th>Name</th>
						<th>Email</th>
						<th>Location</th>
						<th>Action</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(a, i) in attendees" :key="i">
						<td>{{i + 1}}</td>
						<td>{{a['name']}} <small>{{a['role']}}</small></td>
						<td>{{a['email']}}</td>
						<td><span v-if="a.city">{{a.city}},</span> {{a.country}}</td>
						<td>
							<button class="btn btn-primary btn-sm" @click="setProfile(a)" data-toggle="modal" data-target="#profile">Business Card <i class="fa fa-edit"></i></button>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div style="margin: 10%;" v-else>
				<div class="text-center">
					<svg
						width="250"
						height="250"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
					>
						<image
							href="../../assets/pleasure.svg"
							style="color: #fbaf28 !important;"
							width="250"
							height="250"
						/>
					</svg>
					<p >All Attendees list will show up here, <br> so you can have list of all attendees to view.</p>
				</div>
			</div>
		</div>
<!--		<div class="text-center mt-4">-->
<!--			<h5 class="card-title">No attendees</h5>-->
<!--			<p class="card-text">Please create event and invite people, list of all attendees of all events will appear here.</p>-->
<!--		</div>-->
		<!-- Modal -->
		<div class="modal fade" id="profile" tabindex="-1" role="dialog" aria-labelledby="profile" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-body">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<div class="row">
							<div class="col-4 text-center">
								<img class="img-fluid" :src="profile.photoURL" :alt="profile.name" style="border-radius: 50%;">
								<br>
								<div class="text-center mt-3 ml-3">
									<a class="mr-2"  v-if="profile.linkedin_url" :href="profile.linkedin_url" target="_blank"><i class="fab fa-linkedin" style="font-size: 25px;"></i></a>

									<a class="mr-2"   v-if="profile.fb_url" :href="profile.fb_url" target="_blank"><i class="fab fa-facebook-square" style="font-size: 25px;"></i></a>

									<a class="mr-2"  v-if="profile.twitter_url" :href="profile.twitter_url" target="_blank"><i class="fab fa-twitter-square" style="font-size: 25px;"></i></a>
								</div>
							</div>
							<div class="col-8">
								<div class="name">
									<small>Name</small><br>
									<p><b>{{profile.name}}</b></p>
								</div>
								<div class="email">
									<small>Email</small> <br>
									<p><b>{{profile.email}}</b></p>
								</div>
								<div class="profession">
									<small>Profession</small><br>
									<p><b>{{profile.designation}}, {{profile.company}}</b></p>
								</div>
								<div class="location">
									<small>Location</small><br>
									<p><span v-if="profile.city"><b>{{profile.city}},</b></span> <b>{{profile.country}}</b></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
  import createEvent from '@/components/dashboard/create-event.vue'

  export default {
    name: 'event-attendees',
    data() {
      return {
        is_create: false,
        attendees: [],
	      profile: {},
      }
    },
    props: ['event'],
    components: {
      createEvent
    },
    mounted() {
      this.$root.$on("createEvent", () => {
        this.is_create = true
      });
      this.getAttendeesFunction()
    },
    methods: {
        setProfile: function(user) {
            this.profile = user
        },
        getAttendeesFunction: function () {
            this.$store.dispatch('getEventAttendees', this.event).then(resp => {
                if (resp.data.status === "success") {
                this.attendees = resp.data.data
                }
            })
        }
    }
  }
</script>
